<template>
  <voice-item1 :data="data"></voice-item1>
  <!--<a-tabs v-model="doingViewKey"  >-->
    <!--<a-tab-pane  key="1" tab="校对核查" >-->
      <!--<voice-item1 :data="data"></voice-item1>-->
    <!--</a-tab-pane>-->
    <!--<a-tab-pane  key="2" tab="问卷列表" >-->
      <!--<voice-item2 :form-id="data.paFormId"></voice-item2>-->
    <!--</a-tab-pane>-->
  <!--</a-tabs>-->
</template>

<script>
  import { getAction ,postAction} from '@/api/manage'

  import VoiceItem1 from './voice/item/VoiceItem1'
  import VoiceItem2 from './voice/item/VoiceItem2'
  export default {
    name: 'VoiceItem',
    components: { VoiceItem1,VoiceItem2 },
    data(){
      return {
        doingViewKey:'1',
        data:{},
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      onChange(index){
        this.doingViewKey = (index+2)+''
      },
      loadData(){
        getAction('/voice/voiceApplyForm/queryById',{id:this.$route.params.id}).then(res=>{
          if(res.success){
            this.data =res.result
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
<style lang="less">
</style>